import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './App.css';
import Home from './pages';
import Mint from './pages/mint';
import Token from './pages/token';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home className='App' />} />
        <Route path='/mint' element={<Mint />} />
        <Route path='/token' element={<Token />} />
      </Routes>
      {/* <Route path='/mint' element={<div></div>} /> */}
    </Router>
  );
}

export default App;
